<template>
  <div
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-click-outside="toggleItemOuter"
  >
    <div v-show="hasError" class="erorr-message">{{ errorMessage }}</div>
    <div
      class="lego-dropdown__title"
      :class="{ 'is-item-showing': isItemShowing }"
      @click="toggleItem"
    >
      <div class="lego-dropdown__selected" ref="widthDiv" :style="dropdownTitleStyle">
        <div style="display: flex" v-lego-tooltip:ellipsis="textToolTip">
          <span :style="styleTextSelected">
            <span style="text-overflow: ellipsis; width: 100%">{{ textSelected }}</span>
          </span>
          <span
            v-if="isMultiSelect"
            style="text-overflow: unset; min-width: max-content; margin-left: 3px"
            >{{ countSelected }}</span
          >
        </div>
      </div>

      <lego-icon-wrapper style="width: 18px; margin-left: 12px">
        <lego-icon class="lego-dropdown__icon" icon="expand_menu" size="12px" :style="caretStyle" />
      </lego-icon-wrapper>
    </div>
    <div class="lego-dropdown__downwrap" v-if="isItemShowing">
      <div class="lego-dropdown__tags">
        <NullWidget v-if="items == undefined || items.length === 0" style="min-height: 134px" />
        <div v-if="hasSearchField && items.length > 0" class="auto-complete__search-box">
          <lego-text-field
            ref="filterInput"
            :placeholder="searchPlaceholder || $t('label.targetPlaceholder')"
            v-model="filterText"
            :isHideSpecialCharacter="true"
            searchable
            counter="100"
            :isCounter="false"
            @update:modelValue="filterTextOnInput"
            :mutateInput="mutateInput"
          />
        </div>
        <div v-if="getFilterItems.length > 0" class="lego-dropdown__selectall-wrap">
          <div
            class="lego-dropdown__item lego-dropdown__selectall"
            v-show="selectAll"
            @click="clickSelectAll"
          >
            <lego-checkbox
              :indeterminate="selectAllChecked && selectAllCheckedIcon === 'indeterminate'"
              :checked="selectAllChecked"
              :checked-icon="selectAllCheckedIcon"
              @click="clickSelectAll"
              >{{ $t('label.all') }}</lego-checkbox
            >
          </div>
          <!-- <div
            class="lego-dropdown__item lego-dropdown__selectall"
            v-show="selectAll" @click="clickSelectAll">
            <lego-checkbox
              :checked="selectAllChecked"
              :checked-icon="selectAllCheckedIcon"
              @click="clickSelectAll">전체 선택</lego-checkbox>
          </div> -->
        </div>
        <c-scroll
          :style="
            getFilterItems.length > 0 && items != undefined && items.length > 0
              ? { maxHeight: getFilterItems.length > 9 ? '306px' : 'auto' }
              : ''
          "
        >
          <NullWidget
            v-if="getFilterItems.length === 0 && items != undefined && items.length > 0"
            style="min-height: 134px"
          />
          <div class="lego-dropdown__items">
            <!-- <div class="lego-dropdown__items" :style="[dropdownWidth]"> -->
            <div
              class="lego-dropdown__item"
              :class="{ 'item-checked': item.check }"
              v-for="(item, idx) in getFilterItems"
              :key="idx"
              @click="onClickItem(item)"
            >
              <div v-if="item.key !== null && item.value !== null" class="lego-dropdown__label">
                <lego-checkbox
                  :value="item"
                  :checked="selected"
                  @click="onClickItem(item)"
                  :valueKey="valueKey"
                >
                  <em class="ellipsis" v-lego-tooltip:ellipsis="getTagText(item)">{{
                    getTagText(item)
                  }}</em>
                  <!-- <div v-lego-tooltip:ellipsis="'말줄임이 길면 툴팁이 노출됩니다.'">말줄임이 길면 툴팁이 노출됩니다.</div> -->
                  <!-- <lego-tooltip left mouseOver>{{getTagText(item)}}</lego-tooltip> -->
                  <!-- {{`${item.key} : ${item.value}`}} -->
                </lego-checkbox>
              </div>
            </div>
          </div>
        </c-scroll>
        <!--<div class="lego-dropdown__apply lego-dropdown__apply_pos" v-show="applyBtn" :style="[dropdownWidth]">-->
        <div class="lego-dropdown__apply-wrap">
          <div class="lego-dropdown__apply lego-dropdown__apply_pos" v-show="applyBtn">
            <lego-button @click="onApplyClick">{{ $t('button.apply') }}</lego-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import legoDropdown from '@/lego-component/components/element/legoDropdown/legoDropdown.vue';
import cScroll from '../../cmp/cScroll/cScroll.vue';
import NullWidget from '@/containers/widget/components/NullWidget.vue';
// lego-multi-dropdown은 lego-dropdown을 상속받은 컴포넌트 입니다. lego-dropdown의 모든 속성을 그대로 사용합니다.
// #lego-multi-dropdown is a component that inherits lego-dropdown. Accept all the properties of lego-dropdown.
export default {
  mixins: [i18nMixin],
  name: 'scpm-tag-dropdown',
  emits: ['update:modelValue', 'tag-input'],
  components: { cScroll, NullWidget },
  extends: legoDropdown,

  props: {
    // $ver: v0.1.2
    // $v-model
    // 드랍다운 리스트의 선택된 값 입니다.
    // #The selected value in the drop-down list.
    modelValue: {
      type: [Array, String],
      default: () => []
    },
    // $ver: v0.1.2
    // Apply 버튼을 표시합니다.
    // #Display the Apply button.
    // $default: false
    applyBtn: { type: Boolean, default: false },

    // $ver: v0.1.2
    // Select All 기능을 표시합니다.
    // #Displays the Select All function.
    // $default: false
    selectAll: { type: Boolean, default: false },
    mutateInput: { type: Function, default: null },
    hasSearchField: { type: Boolean, default: false },
    searchPlaceholder: { type: String, default: '' },
    showOnlyKey: { type: Boolean, default: false },
    isChangeTextShow: { type: Boolean, default: false },
    isTarget: { type: Boolean, default: false },
    maxSelect: { type: [Number, String], default: '' },
    messageErrorMaxSelect: { type: String, default: '' },
    isCustomComMonConfig: { type: Boolean, default: false },
    isStaticType: { type: Boolean, default: false },
    isEventFiltering: { type: Boolean, default: false },
    valueKey: { type: String, default: '' },
    mode: { type: String, default: '' }
  },

  data() {
    return {
      filterText: '',
      selected: [],
      prevSelected: [],
      textToolTip: '',
      textSelected: this.$t('label.all'),
      countSelected: '',
      isMultiSelect: false,
      hasError: false,
      errorMessage: '',
      tmpSelected: [],
      keysRenderTpl: [] // [text, key, value]
    };
  },

  computed: {
    getFilterItems() {
      let findItems = [];
      if (this.items != undefined) {
        for (let i = 0; i < this.items.length; i++) {
          let _item = this.items[i];
          _item['check'] = false;
          if (!(this.filterText && this.filterText.length > 0) || this.checkFindItems(_item)) {
            _item['idx'] = i;
            findItems.push(_item);
          }
        }
      }

      if (!Array.isArray(this.selected)) {
        this.selected = [];
      }

      // 체크여부
      for (let i = 0; i < findItems.length; i++) {
        let _item = findItems[i];

        let selectedIndex = -1;

        if (this.isCustomComMonConfig) {
          selectedIndex = this.selected.findIndex((row) => row.value === _item.value);
        } else {
          selectedIndex = this.selected.findIndex((row) => row.key === _item.key);
        }

        if (-1 < selectedIndex) {
          _item['check'] = true;
        }

        if (this.isCustomComMonConfig) {
          this.selected.forEach((item) => {
            if (item.value.toString() === _item.value.toString() && item.idx != _item.idx) {
              item.idx = _item.idx;
            }
          });
        }
      }
      return findItems;
    },

    dropdownTitleStyle() {
      if (this.selected.length === 0) {
        this.textSelected = this.$t('label.all');
        this.countSelected = '';

        return { color: '#a5a7ad' };
      } else {
        return { color: '#000' };
      }
    },

    selectAllChecked() {
      return this.selected.length > 0;
    },

    selectAllCheckedIcon() {
      if (this.hasSearchField) {
        return this.getFilterItems.every((item) => item.check === true)
          ? 'checked'
          : 'indeterminate';
      }
      return this.selected.length === this.items.length ? 'checked' : 'indeterminate';
    },

    styleTextSelected() {
      let style = {};

      style['width'] = 'auto';
      style['text-overflow'] = 'ellipsis';
      style['max-width'] = '100%';

      return style;
    }
  },

  watch: {
    isItemShowing() {
      if (this.applyBtn && this.isItemShowing) {
        this.prevSelected = this.selected.slice();
      }
    },
    modelValue() {
      if (this.mode === 'logCollection' && this.modelValue.length > 0) {
        if (!_.isEqual(this.selected, this.modelValue)) {
          if (this.getFilterItems.length) {
            this.getFilterItems.forEach((item, idx) => {
              this.modelValue.forEach((e) => {
                if (e.key === item.key && !this.selected.find((i) => i.key === e.key)) {
                  this.selected.push({ ...e, idx: idx });
                }
              });
            });
            this.getSelectedItemText();
          }
        }
      } else {
        this.selected = this.modelValue.slice();
        this.getSelectedItemText();
      }
    }
  },
  mounted() {
    if (this.mode === 'logCollection' && this.modelValue.length > 0) {
      if (!_.isEqual(this.selected, this.modelValue)) {
        if (this.getFilterItems.length) {
          this.getFilterItems.forEach((item, idx) => {
            this.modelValue.forEach((e) => {
              if (e.key === item.key && !this.selected.find((i) => i.key === e.key)) {
                this.selected.push({ ...e });
              }
            });
          });
          this.getSelectedItemText();
        }
      }
    } else {
      this.selected = this.modelValue.slice();
      this.getSelectedItemText();
    }
  },

  methods: {
    checkFindItems(_item) {
      for (let i = 0; i < this.keysRenderTpl.length; i++) {
        if (
          _item[this.keysRenderTpl[i]] &&
          _item[this.keysRenderTpl[i]].toLowerCase().includes(this.filterText.toLowerCase())
        ) {
          return true;
        }
      }

      return false;
    },

    filterTextOnInput() {
      this.filterText = this.filterText.trim();
    },

    getSelectedItemText() {
      if (this.selected.length === 0 || this.selected.length === this.items.length) {
        this.textSelected = this.$t('label.all');
        this.countSelected = '';
      } else {
        let itemText = [];
        let firstIdx = 0;
        let idx = 0;
        const count = this.selected.length;

        if (this.isEventFiltering) {
          this.items.forEach((_item) => {
            this.selected.forEach((item) => {
              if (item.value.toString() === _item.value.toString() && item.idx != _item.idx) {
                item['idx'] = _item.idx;
                item['value'] = _item.value.toString();
                item['ip'] = _item.ip;
                item['tag'] = _item.tag;
                item['key'] = _item.key;
                item['version'] = _item.version;
                _item['check'] = true;
              }
            });
          });
        }

        if (this.selected.length > 1) {
          idx = Math.min(...this.selected.map((item) => item.idx));
          firstIdx = this.selected.findIndex((item) => item.idx === idx);
        }

        if (typeof this.itemText === 'function') {
          itemText.push(this.itemText(item));
        } else if (this.isCustomComMonConfig) {
          itemText.push(this.selected[firstIdx].text);
        } else {
          if (this.showOnlyKey) {
            if (this.isChangeTextShow) {
              itemText.push(this.selected[firstIdx].value);
            } else {
              itemText.push(this.selected[firstIdx].key);
            }
          } else {
            itemText.push(
              this.selected[firstIdx].key.concat(
                this.selected[firstIdx].value ? `:${this.selected[firstIdx].value}` : ''
              )
            );
          }
        }

        this.textToolTip = itemText.toString();
        this.textSelected = itemText.toString();
        this.countSelected = '';

        if (count > 1) {
          this.isMultiSelect = true;
          this.textToolTip = this.textToolTip + ' ' + this.$t('label.andOther', [count - 1]);
          this.countSelected = this.$t('label.andOther', [count - 1]);
        } else {
          this.isMultiSelect = false;
          this.countSelected = '';
        }
      }
    },

    getTagText(item) {
      let itemText = '';
      let keyNeedSearch = [];
      if (item.value === undefined) {
        itemText = item.key;
        keyNeedSearch = ['key'];
      } else {
        itemText = item.key + ':' + item.value;
        keyNeedSearch = ['key', 'value'];
      }

      if (this.showOnlyKey) {
        itemText = item.value;
        keyNeedSearch = ['value'];
      }

      if (this.isCustomComMonConfig) {
        itemText = item.text;
        keyNeedSearch = ['text'];
      }

      // Set key renderTPL for check filter text
      if (!this.keysRenderTpl.length) {
        this.keysRenderTpl = keyNeedSearch;
      }

      return itemText;
    },

    onClickItem(item) {
      let indexInSelected = -1;

      if (this.isCustomComMonConfig) {
        indexInSelected = this.selected.findIndex((itemAll) => itemAll.value === item.value);
      } else {
        indexInSelected = this.selected.findIndex((itemAll) => itemAll.key === item.key);
      }

      if (indexInSelected > -1) {
        this.selected.splice(indexInSelected, 1);
      } else {
        if (this.maxSelect && this.selected.length >= this.maxSelect) {
          this.hasError = true;
          this.errorMessage = this.messageErrorMaxSelect;
          return;
        }

        this.selected.push({ ...item, check: true });
      }

      this.getSelectedItemText();

      if (!this.applyBtn) {
        this.$emit('tag-input', this.selected);
      }
      this.$emit('update:modelValue', this.selected);
    },

    toggleItem() {
      this.resetSelected();
      this.isItemShowing = !this.isItemShowing;
    },

    toggleItemOuter() {
      this.resetSelected();
      this.isItemShowing = false;
    },

    resetSelected() {
      if (this.applyBtn && this.isItemShowing) {
        this.selected = this.prevSelected.slice();
      }
    },

    onApplyClick() {
      this.$emit('tag-input', this.selected);
      this.isItemShowing = false;
    },

    clickSelectAll() {
      const ableItem = this.items.filter((item) => {
        return !item.disabled;
      });

      if (this.maxSelect && ableItem.length > this.maxSelect) {
        this.hasError = true;
        this.errorMessage = this.messageErrorMaxSelect;
        return;
      }

      // Uncheck
      if (this.selectAllCheckedIcon == 'checked') {
        this.getFilterItems.map((item) => {
          let indexSelectedInAll = -1;

          if (this.isCustomComMonConfig) {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.value === itemAll.value);
          } else {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.key === itemAll.key);
          }

          indexSelectedInAll > -1 && this.selected.splice(indexSelectedInAll, 1);
        });
      } else {
        this.getFilterItems.map((item) => {
          let indexSelectedInAll = -1;

          if (!this.isCustomComMonConfig) {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.key === itemAll.key);
          } else {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.value === itemAll.value);
          }

          indexSelectedInAll === -1 && this.selected.push({ ...item, check: true });
        });
      }

      this.getSelectedItemText();

      if (!this.applyBtn) {
        this.$emit('tag-input', this.selected);
      }
      this.$emit('update:modelValue', this.selected);
    },

    clearInputSearch() {
      this.filterText = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.auto-complete__search-box {
  padding: 12px;
}

.erorr-message {
  font-size: 12px;
  color: #fc434e;
}

.lego-dropdown {
  min-width: 80px;
  width: 100%;
  &__title {
    border-radius: 2px;

    &.is-item-showing {
      border-color: $lego-dropdown__title__border--focus;
    }

    .lego-dropdown__selected {
      display: block;
      line-height: 30px;
      width: calc(100% - 24px);
      color: #a5a7ad;
      span {
        display: inline-block;
        @include ellipsis;
      }

      &.placeholder {
        color: $color--ui06;
      }
    }
  }

  &__title-icon {
    .lego-dropdown__icon {
      font-size: 12px;
    }
  }

  .lego-dropdown__title {
    &:focus {
      border: $lego-dropdown__title__border;
    }
    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
  }

  &--borderless {
    width: auto;
    min-width: auto;
    .lego-dropdown__title {
      border: 0 !important;

      .lego-dropdown__selected {
        flex-grow: 1;
      }
    }

    &.lego-dropdown--disabled {
      .lego-dropdown__title {
        background: none !important;
      }
    }
  }

  &--readonly {
    pointer-events: none;
    cursor: default;
    .lego-dropdown__title {
      border: $lego-dropdown__title__border--disabled;
      background-color: $lego-dropdown__title__background-color--readonly;
    }
  }

  &--small {
    min-width: $lego-dropdown__min-width--small;
    .lego-dropdown__title-icon {
      .lego-dropdown__icon {
        font-size: 10px;
      }
    }
  }
}

:deep .lego-button--border.lego-button--default {
  font-weight: 700;
  background-color: #364fc7;
  border-color: #364fc7;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  border-radius: 2px;
  height: 24px;
  min-width: 70px;
  padding: 0 8px;
  cursor: pointer;

  &:hover {
    background-color: #2b3f9f;
    border-color: #2b3f9f;
  }
}

:deep .lego-dropdown__downwrap {
  width: 100%;
}

.lego-dropdown__tags {
  // position: relative;
  // padding: 0 10px;
  background-color: #ffffff;
  border: 1px solid #364fc7;
}
:deep .lego-dropdown__item {
  padding: 0 12px 0 12px;

  &.item-checked,
  &:hover {
    background-color: #eff1fb;
    .lego-dropdown__label {
      .lego-checkbox__label {
        color: #2f3237;
        font-weight: 400;
      }
    }
  }
}
:deep .lego-dropdown__selectall {
  display: block !important;
  border: 0;
  border-bottom: 1px solid #e4e5e7;
  line-height: 24px;
  min-height: 34px;
  max-height: 48px;

  .lego-dropdown__item .lego-checkbox__checked + .lego-checkbox__label,
  .lego-checkbox__label {
    color: #2f3237 !important;
    font-weight: 700;
    padding-top: 1px;
  }
  &:hover {
    background-color: #eff1fb !important;
  }
}
:deep .lego-dropdown__items {
  // margin-bottom: 42px;
  max-height: initial;
  border: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}
.lego-dropdown__selectall-wrap {
  padding: 0 0px;

  .lego-dropdown__item {
    &:hover {
      background-color: transparent;
    }
  }
}
.lego-dropdown__apply-wrap {
  padding: 0 10px;
}
// .lego-dropdown__apply-wrap {
//   position: absolute;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: #fff;
// }
:deep .lego-dropdown__apply {
  border: 0;
  border-top: 1px solid #a5a7ad;
}
:deep .lego-button--default:not(.lego-button--loading):hover {
  background-color: #2b3f9f !important;
}
:deep .lego-checkbox__label {
  display: block;
  width: calc(100% - 10px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #2f3237;
  padding-top: 1px;

  em {
    display: block;
    font-style: normal;
    @include ellipsis;
  }
}
:deep .lego-dropdown__label {
  flex: 0 1 auto;
  display: block;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}
:deep .lego-checkbox {
  display: block;
  flex: 0 1 auto;
  align-items: flex-start;
  padding: 5px 0 0 15px;
}
:deep .lego-checkbox__icon {
  position: absolute;
  top: 8px;
  left: 0;
}
</style>
